/**
* @name: cell-content-show
* @author: weiyong
* @date: 2025-02-09 14:45
* @description：cell-content-show
* @update: 2025-02-09 14:45
*/
<template>
  <template v-if="column.showToolTip">
    <a-tooltip placement="top">
      <template #title>
        <span>{{ cellContent }}</span>
      </template>
      <div v-if="hasDisplayContent" v-html="cellContent" :title="cellContent" :class="[extendClass]" class="text-dian-dian"></div>
    </a-tooltip>
  </template>
  <template v-else>
    <div v-if="hasDisplayContent"  v-html="cellContent" :title="cellContent" :class="[extendClass]" class="text-dian-dian"></div>
    <div  v-else :title="cellContent" :class="[extendClass]" class="text-dian-dian">&nbsp;</div>
  </template>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "cell-content-show",
});
</script>

<script lang="ts" setup>
import {Tooltip as ATooltip} from 'ant-design-vue';
import {hasGridCellDisplayValue} from '@/utils/comUtils';

interface IProps {
  extendClass:string,
  column: any,
  cellContent: any,
  showValFlag: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  extendClass:'w100b',
  column: {},
  cellContent: '',
  showValFlag: true,
})

const hasDisplayContent = computed(() => hasGridCellDisplayValue(props.cellContent));

</script>

<style type="text/css" lang="less">

</style>
